import { CampaignTemplatePreview } from 'modules/templateEditor/integrations/CampaignTemplatePreview';
import { PreviewWrapper } from './TemplateContent.styles';

export const TEMPLATE_PREVIEW_TEST_ID = 'template-preview-test-id';
export const CAMPAIGN_TEMPLATE_PREVIEW_TEST_ID = 'campaign-template-preview-test-id';

/*
 * For now we are checking if the templateId if available on the campaign as we are assuming that there's already a template associated with the campaign. Once we move
 * to selecting the the template during the campaign creation, we will be deriving the templateId from two sources (campaign.templateId || selectedTemplated.id).
 */

export const TemplatePreview = () => {
  return (
    <PreviewWrapper data-test={TEMPLATE_PREVIEW_TEST_ID}>
      <CampaignTemplatePreview data-test={CAMPAIGN_TEMPLATE_PREVIEW_TEST_ID} />
    </PreviewWrapper>
  );
};
